export enum CostTypeEnum {
    do = "DO",
    dedicated_staff = "Personal Dedicado",
    salon = "Salones",
    consulting = "Consultoría",
    it_costs = "Costos TI",
    other_expenses = "Otros Gastos"
}
